import { BRAND, isMarketGB } from 'src/constants/main';
import { SaveYourProjectAndContinueStyled } from './SaveYourProjectAndContinueStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { SaveYourProjectAndContinueStyledAC } from './AC/SaveYourProjectAndContinueStyledAC';
import { SaveYourProjectAndContinueStyledAP } from './AP/SaveYourProjectAndContinueStyledAP';
import { SaveYourProjectAndContinueStyledDS } from './DS/SaveYourProjectAndContinueStyledDS';
import { SaveYourProjectAndContinueStyledOV } from './OV/SaveYourProjectAndContinueStyledOV';
import { SaveYourProjectAndContinueStyledOVGB } from './OV/SaveYourProjectAndContinueStyledOVGB';
import { Pages } from 'src/types/pages';

export interface SaveYourProjectAndContinueProps extends SC {
    page: Pages;
    isCtaDisabled?: boolean;
}

export const SaveYourProjectAndContinue = (props: SaveYourProjectAndContinueProps) => {
    if (BRAND === 'AC') return <SaveYourProjectAndContinueStyledAC {...props} />;
    if (BRAND === 'AP') return <SaveYourProjectAndContinueStyledAP {...props} />;
    if (BRAND === 'DS') return <SaveYourProjectAndContinueStyledDS {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <SaveYourProjectAndContinueStyledOVGB {...props} />
        ) : (
            <SaveYourProjectAndContinueStyledOV {...props} />
        );
    return <SaveYourProjectAndContinueStyled {...props} />;
};

export default SaveYourProjectAndContinue;
